import { useEffect, useRef, useState } from "react";

export const useScrollCard = () => {
  const [isLeftHidden, setIsLeftHidden] = useState(true);
  const [isRightHidden, setIsRightHidden] = useState(true);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const scrollRight = () => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      const scrollOffset = wrapper.scrollWidth - wrapper.clientWidth;
      wrapper.scrollBy({
        left: scrollOffset,
        behavior: "smooth",
      });
    }
  };
  const scrollLeft = () => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      wrapper.scrollBy({
        left: -500,
        behavior: "smooth",
      });
    }
  };

  const checkScrollPosition = () => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      setIsLeftHidden(wrapper.scrollLeft === 0);
      setIsRightHidden(
        Math.abs(
          wrapper.scrollLeft - (wrapper.scrollWidth - wrapper.clientWidth)
        ) <= 5
      );
    }
  };

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      checkScrollPosition();
      wrapper.addEventListener("scroll", checkScrollPosition);
    }
    return () => {
      if (wrapper) {
        wrapper.removeEventListener("scroll", checkScrollPosition);
      }
    };
  }, []);

  return {
    isLeftHidden,
    isRightHidden,
    scrollRight,
    scrollLeft,
    checkScrollPosition,
    wrapperRef,
  };
};
